module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_8011.4dfc22e3.png";